<template>
  <div class="article_title_font" :id="itemId">
    <div
      :class="isTitle ? 'article_title' : 'article_sub_title'"
      v-html="title"
    ></div>
    <div class="article_sub_title">{{ subTitle }}</div>
  </div>
</template>
<script>
export default {
  props: {
    isTitle: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ""
    },
    subTitle: {
      type: String,
      default: ""
    },
    itemId: {
      type: String,
      default: ""
    }
  }
};
</script>
<style scoped>
.article_title_font {
  padding: 15px 15vw;
  /* width: 100vw; */
  text-align: center;
}
.article_title {
  font-size: 26px;
  font-weight: bold;
}
.article_sub_title {
  font-size: 16px;
  padding-top: 8px;
}
</style>
